export default {
  sm: `
  지금 이 시간에도
  전 세계 수많은 사람들이
  동시에 <s>엄청난 양의</s> 
  <s>데이터를 생성하고</s> 
  <s>이용</s>하고 있습니다.
  `,
  lg: `
  지금 이 시간에도 
  전 세계 수많은 사람이 동시에 
  엄청난 양의 데이터를 
  생성하고 이용하고 있습니다.
  `
};
